<template>
  <div>
    <div class="c-grid">
      <div class="c-grid__items">
        <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__9">
          <section class="p-box">
            <Loading v-show="notification_loading" />
            <template v-if="notification && !notification_loading">
              <div class="p-box__header">
                <h3 class="p-box__title">
                  <span class="p-box__date">{{ basicDateJaFormat(notification.data.attributes.published_at) }}</span>
                  <span v-if="notification.data.attributes.category_name">
                    【{{ notification.data.attributes.category_name }}】
                  </span>
                  {{ notification.data.attributes.title }}
                </h3>
              </div>
              <KkMarkdownView
                class="p-box__body notification__body"
                :content="sanitize(notification.data.attributes.body)"
              />
            </template>
          </section>
        </div>

        <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__3">
          <section class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title p-box__title--narrowWidth">最新のお知らせ</h3>
            </header>
            <div class="p-box__body p-box__body--narrowWidth">
              <Loading v-show="notifications_loading" />
              <template v-if="notifications && !notifications_loading">
                <ul v-if="notifications.data.length">
                  <li
                    v-for="(notification, i) in notifications.data"
                    :key="i"
                    class="c-infoB"
                  >
                    <div class="c-infoB__content">
                      <p>{{ basicDateJaFormat(notification.attributes.published_at) }}</p>
                      <div
                        v-if="notification.attributes.important"
                        class="c-infoB__icon"
                      >
                        <img :src="iconExclamationBPath">
                      </div>
                      <router-link :to="`/s/companies/${ $route.params.company_uuid }/notifications/${ notification.id }`">
                        <span v-if="notification.attributes.category_name">
                          【{{ notification.attributes.category_name }}】
                        </span>
                        {{ notification.attributes.title }}
                      </router-link>
                    </div>
                  </li>
                </ul>
                <div v-else>
                  表示できるデータがありません
                </div>
              </template>
            </div>
            <footer class="p-box__footer u-taR">
              <router-link class="u-colorPrimary" :to="`/s/companies/${ $route.params.company_uuid }/notifications`">
                お知らせ一覧を見る
              </router-link>
            </footer>
          </section>

          <section class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title p-box__title--narrowWidth">集客ニュース・ノウハウ</h3>
            </header>
            <div class="p-box__body p-box__body--narrowWidth">
              <Loading v-show="articles_loading" />
              <template v-if="articles">
                <div v-if="articles.data.length">
                  <ul>
                    <li
                      v-for="( article, i ) in articles.data"
                      :key="i"
                      class="c-infoC"
                    >
                      <div class="c-infoC__eyeCatch"><img alt="" :src="article.img_src"></div>
                      <div class="c-infoC__content"><a :href="article.link" target="_blank">{{ article.title }}</a></div>
                    </li>
                  </ul>
                </div>
                <p v-else>表示できるデータがありません</p>
              </template>
            </div>
            <footer class="p-box__footer u-taR">
              <a class="u-colorPrimary" href="https://lab.kutikomi.com?utm_source=rss" target="_blank">もっと見る</a>
            </footer>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DOMPurify from 'dompurify'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import Loading from '../components/Loading.vue'
import { KkMarkdownView } from '../components/base'
import iconExclamationBPath from '../../../images/common/icon_exclamationB.svg'

export default {
  name: 'CompaniesNotification',
  components: {
    Loading,
    KkMarkdownView
  },
  data: function() {
    return {
      iconExclamationBPath,
    }
  },
  computed: {
    ...mapState({
      notifications: state => state.companiesDashboardNotifications.data,
      notification: state => state.companiesNotification.data,
      articles: state => state.companiesArticles.data,
      notifications_loading: state => state.companiesDashboardNotifications.loading,
      notification_loading: state => state.companiesNotification.loading,
      articles_loading: state => state.companiesArticles.loading,
    })
  },
  watch: {
    '$route' (to, from) {
      if ( from.params.id !== to.params.id ) {
        this.readNotification({ company_uuid: this.$route.params.company_uuid, id: to.params.id })
      }
    }
  },
  created: function() {
    this.readNotification({ company_uuid: this.$route.params.company_uuid, id: this.$route.params.id })
    if (!this.notifications) {
      this.readNotifications(this.$route.params.company_uuid)
    }
    if (!this.articles) {
      this.readArticles()
    }
  },
  methods: {
    ...mapActions({
      readNotification: 'companiesNotification/readNotification',
      readNotifications: 'companiesDashboardNotifications/readNotifications',
      readArticles: 'companiesArticles/readArticles',
    }),
    basicDateJaFormat: function( date ) {
      return date ? moment( date ).format(this.$t('format.date.default')) : ''
    },
    sanitize(html) {
      return DOMPurify.sanitize(html)
    },
  }
}
</script>

<style lang="scss" scoped>
.notification {
  &__body {
    white-space:pre-wrap;
  }
}

</style>
